import APIHelper from "../common/ApiHelper";
import APIURLConstants from "../common/ApiURLConstants";
import { authHeader } from "../helper";

export const sportsRadarService = {
  getPlayerListByCombineYear,
  refreshPlayerDetails,
};
async function getPlayerListByCombineYear(combineYear, playerId) {
  const response = await APIHelper.get(
    `${APIURLConstants.GET_SPORTS_RADAR_PLAYER_DATA}/${combineYear}/${playerId}`,
    authHeader()
  );
  return response;
}

async function refreshPlayerDetails(
  combineYear,
  playerId,
  srPlayerId,
  userBy,
  eventId,
  userID
) {
  const response = await APIHelper.get(
    `${APIURLConstants.REFRESH_SPORTS_RADAR_PLAYER_DATA}/${combineYear}/${playerId}/${srPlayerId}/${userBy}/${eventId}/${userID}`,
    authHeader()
  );
  return response;
}
